// LemmaParseHeadUtils.js (updated with support for lemma_chs expanded details)
import React, { useState } from 'react';
import { SpeakTextButton,LemmaAudioPlayer } from './LemmaPlayUtils';
// import { speakText } from './LemmaTagUtils';
import './LemmaParseHeadUtilstyle.css';

const CmnPhraseDisplay = ({ lemmashead, lemmachs = '[]',headword, showlemma, langcodename}) => {
  const [tempShow, setTempShow] = useState(false);
  const [showMore, setShowMore] = useState(false);

  if (!lemmashead) return null;

  const parse_head = (lemmasHead) => {
    let parsedHead = [];
    try {
      parsedHead = JSON.parse(lemmasHead);
    } catch (error) {
      console.error("Error parsing lemmasHead:", error);
      return <div>Invalid lemmashead format.</div>;
    }

    if (!Array.isArray(parsedHead)) {
      return <div>No lemma lemmashead available.</div>;
    }

    return parsedHead.map(({definition_chs}, index) => (
      <div key={index} className="mb-2">
              {/* {console.log(definition_chs)} */}
        <div><strong>{index + 1}:</strong>
      <strong></strong> {definition_chs?.value}

          <LemmaAudioPlayer aidurl={definition_chs?.aid} aidtext={definition_chs?.value} />
        </div>
      </div>
    ));
  };

  const parseExamples = (examples = []) => {
    if (!Array.isArray(examples) || examples.length === 0) return null;
  
    return (
      <div className="ld-examples">
        {/* <strong>Examples:</strong> */}
        <ul>
          {examples.map((example, idx) => (
            <li key={idx}>
              {example}
              {/* <button 
                onClick={() => speakText(example)} 
                className="speakerStyle"
              >
                🔊
              </button> */}
              <SpeakTextButton headword={example} />
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const parseHeadwordExamples = (examples = [], headword = '') => {
    if (!Array.isArray(examples) || examples.length === 0 || !headword) return null;
  
    const lowerHeadword = headword.toLowerCase();
  
    // Filter examples containing the headword (case-insensitive)
    const filtered = examples.filter(example =>
      example.toLowerCase().includes(lowerHeadword)
    );
  
    if (filtered.length === 0) return null;
  
    return (
      <div className="ld-examples">
        {/* <strong>Examples:</strong> */}
        <ul>
          {filtered.map((example, idx) => (
            <li key={idx}>
              {example}
              {/* <button
                onClick={() => speakText(example)}
                className="speakerStyle"
              >
                🔊
              </button> */}
              <SpeakTextButton headword={example} />
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const parseHeadwordExamplesWithChs = (examples_def = [], examples_def_chs = [], headword = '') => {
  // {console.log(examples_def)};
  // {console.log(examples_def_chs)};
  //  {console.log(headword)};
    if (!Array.isArray(examples_def) || examples_def.length === 0 || !headword) return null;
  
    const lowerHeadword = headword.toLowerCase();
     {console.log(headword)};
    // Find matched indexes
    const matchedIndexes = examples_def_chs
      .map((example, idx) => example.value.toLowerCase().includes(lowerHeadword) ? idx : -1)
      .filter(idx => idx !== -1);
  
    if (matchedIndexes.length === 0) return null;
    // {console.log("headword")};
    return (
      <div className="ld-examples">
        {/* <strong>Examples:</strong> */}
        <ul>
          {matchedIndexes.map((idx) => (
            <li key={idx}>
              {/* English example */}
              {examples_def[idx].value}
              {/* <button
                onClick={() => speakText(examples[idx])}
                className="speakerStyle"
              >
                🔊
              </button> */}
              {/* <SpeakTextButton headword={examples_def[idx]} /> */}
              <LemmaAudioPlayer aidurl={examples_def[idx].aid} aidtext={examples_def[idx].value} />
              {/* Mandarin example if exists */}
              {examples_def_chs[idx] && (
                <>
                  <div style={{ marginTop: '4px', color: '#666' }}>
                    {examples_def_chs[idx].value}
                    {/* <button
                      onClick={() => speakText(examples_chs[idx])}
                      className="speakerStyle"
                    >
                      🔊
                    </button> */}
                    {/* <SpeakTextButton headword={examples_def_chs[idx]} /> */}
                    <LemmaAudioPlayer aidurl={examples_def_chs[idx].aid} aidtext={examples_def_chs[idx].value} />
                  </div>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const parse_lemma_chs = (lemmaChsData) => {
    let parsed = [];
    try {
      parsed = JSON.parse(lemmaChsData);
    } catch (error) {
      console.error("Error parsing lemma_chs:", error);
      return <div>Invalid more lemma data.</div>;
    }

    if (!Array.isArray(parsed)) {
      return <div>No additional lemma data.</div>;
    }

    parsed.sort((a, b) => {
      const aSub = (a.subject || '').split('.')[0];
      const bSub = (b.subject || '').split('.')[0];
      return aSub.localeCompare(bSub);
    });

    return parsed.map((item, index) => (
      <div key={`chs-${index}`} className="ld-expanded-block">
        <div><strong>{index + 1}:</strong> {(item.subject || '').split('.')[0]}
        {/* </div>
        <div> */}
          <strong></strong> {item.definition_chs.value}
          <LemmaAudioPlayer aidurl={item.definition_chs.aid} aidtext={item.definition_chs.value} />
        </div>

        <div class="en-def"><strong></strong> {item.explanation_en.value}
          <LemmaAudioPlayer aidurl={item.explanation_en.aid} aidtext={item.explanation_en.value} />
        </div>
        <div class="chs-def"><strong></strong> {item.explanation_chs.value}
          <LemmaAudioPlayer aidurl={item.explanation_chs.aid} aidtext={item.explanation_chs.value} />
        </div>
        {/* {console.log(item.example_en)} */}
        {parseHeadwordExamplesWithChs(item.example_en,item.example_chs,item.headword.value)}
      </div>
    ));
  };

  return (
    <div className="spStoreAddress">
      {(showlemma === 1 || tempShow) ? (
        <>
          {parse_head(lemmashead)}
          <div className="ld-show-more-btn" onClick={() => setShowMore(!showMore)}>
            👉 Click to show more lemma...
          </div>
          {showMore && parse_lemma_chs(lemmachs)}
        </>
      ) : (
        <div className="blurred-lemma" onClick={() => setTempShow(true)}>
          Click to show lemma
        </div>
      )}
    </div>
  );
};

export default CmnPhraseDisplay;
